export const ErrorCodes = {
  General: "0xD87A",
};
